export enum CredentialType {
  SMS = 'SMS',
  EMAIL = 'EMAIL',
  PIN = 'PIN',
  PASSWORD = 'PASSWORD',
  BIOMETRIC = 'BIOMETRIC',
  WEBAUTHN = 'WEBAUTHN',
  TOTP = 'TOTP',
  PHONE = 'PHONE',
}

export enum ChallengeType {
  EMAIL = 'email',
  PHONE = 'phone',
  WEBAUTHN = 'webauthn',
  BIOMETRIC = 'biometric',
  TOTP = 'totp',
  PASSWORD = 'password',
}

export type ConfirmationRequest = {
  claim: string;
  factors: ConfirmationFactor[];
};

export type ConfirmationFactor = {
  type: string;
  value: string;
};
